import {Calendar} from "primereact/calendar"

export default function DateFilter(props) {
  return (
    <Calendar value={props.value} dateFormat={"dd. mm. yy"} onChange={props.onChange}
              showButtonBar={true} placeholder={props.placeholder}/>
  )
}
